// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__KUEVc","row":"styles_row__2ozkO"};